//region documentFragment
import { buildGraphqlQuery } from '@ztechapps/common.utils'

const documentFragment = `
    _id
    key
    value
    `
//endregion

export const queries = buildGraphqlQuery('AppSetting', documentFragment)
export const buildQuery = (field: string) => buildGraphqlQuery('AppSetting', `_id ${field}`)
